const sampleDrawer = {
  init: function () {
    var $sampleType = $(".js-sampleType");

    if (1 === $sampleType.length) {
      $(".js-sample-submit").removeClass("disabled");
    }

    $("body").on("change", ".js-sampleType", function () {
      $(".js-sample-submit").removeClass("disabled");
    });

    $(".js-drawer-load-on-open").on("ajax-complete", function () {
      const sampleTypeElements = $(this).find(".js-sampleType");
      if (1 === sampleTypeElements.length) {
        $(sampleTypeElements).closest('form').find(".js-sample-submit").removeClass("disabled");
      }

      const inputElement = $(this).find("input[name='sample[type]']");
      if (inputElement.length > 0) {
        inputElement.each(function () {
          const randomId = "sample_type_" + Math.floor(Math.random() * 10000);
          $(this).attr("id", randomId);
          const labelElement = $(this).siblings("label");
          labelElement.attr("for", randomId);
        });
      }
    });

    window.updateQuantity = function (num) {
      const quantityInput = $(".js-quantity-input");
      quantityInput.val(parseInt(quantityInput.val()) + parseInt(num));
      if (quantityInput.val() > 3) {
        quantityInput.val(3);
      }
      if (quantityInput.val() < 1) {
        quantityInput.val(1);
      }
    };
  },
};

module.exports = sampleDrawer;
